import React from 'react';
import { ChevronDown } from 'lucide-react';
export function ContentMapSection() {
  const chapters = [{
    title: 'El mecanismo silencioso',
    desc: 'Comprende lo que el azúcar puede estar haciendo dentro de tu cuerpo sin que lo notes.'
  }, {
    title: 'Identificando las señales',
    desc: 'Aprende a reconocer pequeños mensajes que tu cuerpo ya podría estar enviando.'
  }, {
    title: 'La trampa del supermercado',
    desc: 'Cómo leer etiquetas y detectar el azúcar oculto que casi nadie ve.'
  }, {
    title: 'El protocolo práctico de 14 días',
    desc: 'Un plan simple para empezar a aplicar lo aprendido desde hoy.'
  }, {
    title: 'Bonus — Guía de rescate rápida',
    desc: 'Qué hacer cuando una comida alta en carbohidratos aparece en tu día.'
  }];
  return <section className="py-16 md:py-20 px-4 bg-[#141414]" data-id="element-14">
      <div className="max-w-2xl mx-auto" data-id="element-15">
        <h2 className="text-2xl md:text-3xl font-serif text-center text-white mb-8" data-id="element-16">
          Qué hay dentro (mapa rápido)
        </h2>

        <div className="space-y-3" data-id="element-17">
          {chapters.map((chapter, idx) => <div key={idx} className="bg-[#1a1a1a] p-4 rounded-lg border border-[#2a2a2a] flex items-start justify-between" data-id="element-18">
              <div data-id="element-19">
                <span className="text-white font-medium" data-id="element-20">{chapter.title}:</span>
                <p className="text-[#aaa] text-sm mt-1" data-id="element-21">{chapter.desc}</p>
              </div>
              <ChevronDown className="w-4 h-4 text-[#555] shrink-0 mt-1" data-id="element-22" />
            </div>)}
        </div>
      </div>
    </section>;
}